'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var linkedListUtils = require('./linked-list-utils.js');

const whileLinkedList = (predicate, list, startId) => {
    if (startId && !list.items[startId]) {
        throw new Error('Cannot start from a node that does not exist');
    }
    return linkedListUtils.walkListItemRecord((acc, item) => {
        const itemMatched = predicate(item);
        if (itemMatched) {
            return {
                result: [...acc, item.id],
            };
        }
        return {
            result: acc,
            control: {
                stop: true,
            },
        };
    }, {
        initValue: [],
        startId: startId || list.headId,
        items: list.items,
    });
};

exports.whileLinkedList = whileLinkedList;
//# sourceMappingURL=while-linked-list.js.map
